import React, { useEffect, useRef } from 'react';

/**
 * AdSlot renders a Google AdSense unit. In production it initialises the ad via
 * `(adsbygoogle = window.adsbygoogle || []).push({})`. Until AdSense has actually
 * served an ad the browser renders a subtle placeholder identical to the one the
 * user provided in the reference image ("ADVERTISEMENT" text on a light background).
 *
 * Placement slots are all-purpose "display" units — AdSense chooses the best size
 * (auto). The slot IDs can be overridden per-instance via the `slotId` prop.
 */
export default function AdSlot({ slotId = 'auto', format = 'auto', responsive = 'true', className = '', minH = 90 }) {
  const ref = useRef(null);
  useEffect(() => {
    try {
      if (typeof window !== 'undefined' && window.adsbygoogle) {
        (window.adsbygoogle = window.adsbygoogle || []).push({});
      }
    } catch (e) {
      // Silently swallow — AdSense may be blocked or not loaded yet.
    }
  }, []);
  return (
    <div className={`ad-slot ${className}`} data-testid="ad-slot">
      <div className="ad-label">ADVERTISEMENT</div>
      <ins
        ref={ref}
        className="adsbygoogle"
        style={{ display: 'block', minHeight: minH }}
        data-ad-client="ca-pub-3584823300252981"
        data-ad-slot={slotId}
        data-ad-format={format}
        data-full-width-responsive={responsive}
      />
    </div>
  );
}
